<div class="card">
  <div class="card-header">
    <h2 class="orange-border">
            Role <i class="pi pi-question-circle tooltip-icon" pTooltip="A user's role affects which system functions they will have access to. See individual
            tooltips for a description of which functions are allowed for each role."></i>
  </h2>
</div>
<div class="card-body">
  <div class="row">
    <form [formGroup]="roleForm" class="form-group col-sm-6">
      @for (role of roles; track role; let i = $index) {
        <div>
          <div class="form-check">
            <input (change)="emitSelectedRole()"
              class="form-check-input"
              formControlName="selectedRole"
              type="radio"
              value="{{role.description}}">
            <h3>
              <label class="form-check-label"> {{ role.description }}
                <i class="pi pi-question-circle tooltip-icon" pTooltip="{{getRoleUIMeaning(role)}}"></i>
              </label>
            </h3>
          </div>
        </div>
      }
    </form>
  </div>
</div>
</div>